'use client'

import { useAction } from 'next-safe-action/hooks'

import { sendEmail as _sendEmail, TSendEmailResponse } from '@/entities/auth'
import { CERT } from '@/shared/api'
import { useServerErrorHandler } from '@/shared/config/action'

type ActionProps = {
  onSuccess: (data: TSendEmailResponse) => void
  onError: (errorMessage: string) => void
}

export const useSendEmail = () => {
  const { handleServerError } = useServerErrorHandler()

  const action = useAction(_sendEmail)

  const sendEmailAsync = async (
    email: string,
    { onSuccess, onError }: ActionProps,
  ) => {
    const result = await action.executeAsync({ email })

    if (result?.serverError) {
      const { code } = result.serverError

      if (code === CERT['007']) {
        onError(result.serverError.content)
      } else {
        handleServerError(result.serverError)
      }

      return
    }

    if (result?.data) {
      onSuccess(result.data)
    }
  }

  return { sendEmailAsync, isSending: action.isExecuting }
}
